/* Email sending management section */

//Tools importation
import {auth} from "./APIS"

// 🔐 Función para obtener el token de autenticación
async function getAuthToken() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Usuario no autenticado");
  }
  return await user.getIdToken();
}

// 🔹 Función para enviar invitaciones por correo
export async function sendInvitationEmail(email, emailType, inviteData, hostInfo = {},link) {
  
  try {
    const token = await getAuthToken(); // 🔐 Obtiene el token antes de la solicitud
    
    const emailInformation = filterMessage(inviteData, emailType, hostInfo,link);
    const message = emailInformation.message;
    const subject = emailInformation.subject;

    const response = await fetch("https://apisendemail-lhk2jdx5hq-uc.a.run.app/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // 🔐 Agrega el token en la cabecera
      },
      body: JSON.stringify({
        email,
        subject,
        message,
        data: inviteData,
        emailType
      }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to send email");
    }

    return data;

  } catch (error) {
    console.error("Error sending email:", error.message);
    return { success: false, error: error.message };
  }
}

// 🔹 Función para enviar correos de confirmación de reuniones
export async function sendMeetEmail(email, inviteData, confirmation,link) {
  try {
    const token = await getAuthToken(); // 🔐 Obtiene el token antes de la solicitud

    let url = `jackleckermanwebapp.web.app/mymeets/${link}`;
    let subject = `${confirmation} meeting invitation`;
    let message = `<div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
                    <h2>${inviteData.name} ${inviteData.surname} from ${inviteData.company} has ${confirmation} your meeting.</h2>
                    <p>Log in to the <strong>JackLeckerman Web App</strong> to be able to have more information about the meet.</p>
                    <p>You will find all the meet information, such as location, table, and scheduled times, within the portal.</p>
                    <p><strong>Use this link to access directly:</strong> <a href="${url}" style="color: #ed2824;">${url}</a></p>
                    <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
                    <br>
                    <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
                  </div>`;

    const response = await fetch("https://apisendemail-lhk2jdx5hq-uc.a.run.app/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // 🔐 Agrega el token en la cabecera
      },
      body: JSON.stringify({ email, subject, message, data: inviteData }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to send email");
    }

    return data;

  } catch (error) {
    console.error("Error sending email:", error.message);
    return { success: false, error: error.message };
  }
}

//Funcion para enviar notificaciones de eventos
export async function sendEventNotification(email,messaggeText,inviteData={}) {
  try {
    const token = await getAuthToken(); // 🔐 Obtiene el token antes de la solicitud
    let url = "jackleckermanwebapp.web.app";
    let subject = `Event notification`;
    let message = `<div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
                    <h2>General notice about the event</h2>
                    <p>${messaggeText}</p>
                    <p>Access our portal to see other notifications or active chats you may have. You can access it through the following links.</p>
                    <p><strong>Use this link to access directly:</strong> <a href="${url}" style="color: #ed2824;">${url}</a></p>
                    <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
                    <br>
                    <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
                  </div>`;

    const response = await fetch("https://apisendemail-lhk2jdx5hq-uc.a.run.app/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // 🔐 Agrega el token en la cabecera
      },
      body: JSON.stringify({ email, subject, message, data: inviteData }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to send email");
    }

    return data;

  } catch (error) {
    console.error("Error sending email:", error.message);
    return { success: false, error: error.message };
  }
}
//Function to select respective email
const filterMessage = (data,type,host,link) =>{
    let url = "jackleckermanwebapp.web.app"
    let urlChat = `jackleckermanwebapp.web.app/myChats/${link}`
    let urlMeetInvitation = `jackleckermanwebapp.web.app/mymeets/${link}`
    switch (type) {
        case "invitation":
            return {
              subject:"Event Invitation",
              message:`
            <div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
              <h2>Welcome, ${data.name} ${data.surname}!</h2>
              <p>Log in to the <strong>JackLeckerman Web App</strong></p>
              <p>
                You can access the venue, schedule one-on-one meetings, connect with fellow attendees, stay updated with real-time event schedules, and explore exclusive content and resources.
              </p>
              <p><strong>Use this link:</strong> <a href="${url}" style="color: #ed2824;">${url}</a></p>
              <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
              <h3>Your login credentials:</h3>
              <p><strong>Email:</strong> ${data.email}</p>
              <p><strong>Password:</strong> ${data.password}</p>
              <br>
              <p>Enjoy the Forum, and see you there!</p>
              <br>
              <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
            </div>
          `
        }
        case "meet":
            return {
              subject:"Meeting Invitation",
              message: `<div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
              <h2>${host.name} ${host.surname} from ${host.company} has invited you to a meeting.</h2>
              <p>Log in to the <strong>JackLeckerman Web App</strong> to be able to have more information about the meeting.</p>
              <p>
                You can <strong>Decline</strong> or <strong>Accept</strong> the invitation within our portal.
              </p>
              <p><strong>Use this link to access directly:</strong> <a href="${urlMeetInvitation}" style="color: #ed2824;">${urlMeetInvitation}</a></p>
              <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
              <br>
              <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
            </div>`
            }
        case "confirmation":
            return {
              subject:"Meeting Break Confirmation",
              message:``
            }
        case "coordinator":
            return {
              subject: "Coordinator Profile Created",
              message:`
            <div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
              <h2>Welcome, ${data.name} ${data.surname}!</h2>
              <p>
                Your profile as coordinator has been created. <br>
                Log in to the <strong>JackLeckerman Web App</strong>
              </p>
              <p><strong>Use this link:</strong> <a href="${url}" style="color: #ed2824;">${url}</a></p>
              <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
              <h3>Your login credentials:</h3>
              <p><strong>Email:</strong> ${data.email}</p>
              <p><strong>Password:</strong> ${data.password}</p>
              <br>
              <br>
              <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
            </div>
          `
            }
        case "chat":
          return {
            subject: "You have a new message",
            message:`
          <div style="font-family: Arial, sans-serif; color: #333; width:100%; text-align: center;">
            <h2>${host.name} ${host.surname} has sent you a new message.</h2>
            <p>
              Access our portal to proceed with your conversation.<br>
              Navigate to the event's main page and click the "chat" button to check your active chats.
            </p>
            <p><strong>Use this link:</strong> <a href="${urlChat}" style="color: #ed2824;">${urlChat}</a></p>
            <p>Or visit <a href="https://www.jackleckerman.com" style="color: #ed2824;">www.jackleckerman.com</a></p>
            
            <br>
            <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501351/Logo_qvhw73.png" alt="JackLeckerman Logo" style="width: 200px;">
          </div>
        `
          }
    }
}
